import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import * as Sentry from '@sentry/react'
import './index.css'

import App from './App.jsx'

// Sentry : surveillance des ERREURS, et rien d'autre (production uniquement).
//
// La configuration précédente filmait la session du visiteur
// (replayIntegration, 10 % des sessions et 100 % de celles qui plantent) et
// envoyait ses données personnelles (sendDefaultPii). Elle tournait quel que
// soit le choix fait dans le bandeau de consentement — y compris après un refus
// explicite. Trois raisons de la réduire plutôt que de la conditionner :
//   1. le bandeau ne pouvait de toute façon pas la piloter honnêtement ;
//   2. filmer l'écran d'un acheteur pendant qu'il saisit son adresse n'est pas
//      couvert par l'intérêt légitime, alors que la remontée d'erreur l'est ;
//   3. l'enregistrement de session pesait 119 ko sur CHAQUE visite.
// Les erreurs et leurs traces restent remontées : rien n'est perdu du côté
// diagnostic.
if (import.meta.env.PROD) {
  Sentry.init({
    dsn: 'https://2dc13b77a2534cceeb81356b6a1d0a04@o4510691413327872.ingest.de.sentry.io/4510793541156944',
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
    tracesSampleRate: 0.1,
  })
}

createRoot(document.getElementById('root')).render(
  <StrictMode>
    <App />
  </StrictMode>,
)
